import React, {Fragment} from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import { WithTranslation, withTranslation, Trans } from 'react-i18next';

import QRCode from 'qrcode.react';
import { downloadQR } from 'app/common/helpers';

import { QRCode as QR} from 'react-qrcode-logo';
import CONFIG from 'cfg/config';


type ModalProps = {
    open: boolean,
    toggleDialog : () => void,  
}

class Notifier extends React.Component<ModalProps & WithStyles<typeof styles> & WithTranslation> {
    logoIkonaUrl: string | any = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/startowe_ikona.jpg`;

    componentDidMount() {
        this.imageCheck(this.logoIkonaUrl, require('../assets/icon.png').default)
      }
    
      imageCheck = (url: string, fallback: any) => {
        const img = new Image();
        img.src = url;
    
        if (img.complete) {
          //ok
          return url
        } else {
          img.onload = () => {
            //ok
            return url
          };
    
          img.onerror = () => {
            //error
            this.logoIkonaUrl  = require('../assets/icon.png').default
            return fallback
          };
        }
      }

    qrCodeValue = () => {
        let value = ''
        value = value + `https://vsc24.net/vscHotelBook/hotel/${CONFIG.hotelID}`
        return value
    }

    render() {
        const { classes } = this.props;

        return (
            <Dialog
            maxWidth="xs"
            open={this.props.open}
            onClose={this.props.toggleDialog}
            fullWidth
        >   
            <DialogTitle disableTypography style={{minWidth: "280px", paddingBottom: "0px"}}>
                <Typography variant="h6" component="h2" color="primary">
                    <b><Trans>QR</Trans></b>
                </Typography>
                <hr />
            </DialogTitle> 
            <DialogContent >
                    <div className={classes.qr} >
                        <div onClick={() => downloadQR()} style={{ cursor: "pointer" }}>
                            <QR id="qrCodeMain" value={this.qrCodeValue()} size={300} logoWidth={60} logoHeight={60} removeQrCodeBehindLogo qrStyle="dots"
                                //logoImage={require('../assets/icon.png').default} 
                                logoImage={this.logoIkonaUrl}
                            />
                        </div>
                    </div>
            </DialogContent>
            <DialogActions>
            <Button variant="outlined" color="primary" size="small"
                    onClick={this.props.toggleDialog}>
              <b><Trans>Back</Trans></b>
            </Button>      
          </DialogActions>
        </Dialog>
        );
    }
}

const styles = (theme: Theme) => ({
    textAlignLeft: {
        textAlign: 'left' as 'left',
    },
    fontWeightNormal: {
        fontWeight: 'normal' as 'normal',
    },
    uppercase: {
        textTransform: "uppercase" as "uppercase"
    },
    input: {
        backgroundColor: '#ffffff',
        color: "rgb(0, 0, 0)"
    },
    primary: {
        color: theme.palette.primary.main
    },
    error: {
        color: theme.palette.error.main
    },
    qr: {
        //display: 'none'
        textAlign: "center" as "center",
        //marginTop: "5px"
        //marginTop: "40px",
    },
});

export default withTranslation()(withStyles(styles)(Notifier));